"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readBoolean = exports.writeBoolean = void 0;

var writeBoolean = function writeBoolean(value) {
  return value ? Buffer.from('01', 'hex') : Buffer.from('00', 'hex');
};

exports.writeBoolean = writeBoolean;

var readBoolean = function readBoolean(buffer, offset) {
  return [buffer[offset] !== 0x00, 1];
};

exports.readBoolean = readBoolean;